<template>
    <!-- https://tailwindui.com/components/application-ui/lists/grid-lists#component-5d72b187beb968e12db89fe49f272b18 -->
    <li class="col-span-1 flex flex-col text-center bg-white rounded-lg shadow">
        <div class="flex-1 flex flex-col px-8 py-4">
            <!--            <img class="w-32 h-32 shrink-0 mx-auto bg-black rounded-full" src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&amp;ixid=eyJhcHBfaWQiOjEyMDd9&amp;auto=format&amp;fit=facearea&amp;facepad=4&amp;w=256&amp;h=256&amp;q=60" alt="">-->
            <p class="mt-6 text-md font-medium text-gray-1000 mb-0">{{ meter.name }}</p>
            <span class="px-2 py-1 text-gray-800 text-sm leading-4 font-light w-auto">{{ meter.type }}</span>
            <div class="my-4">
                <select2    :options="alarmProfiles"
                            v-model:value="meter.alarmProfile"
                            placeholder="Please Select a Profile"
                            @input="checkAlarm"></select2>
            </div>
            <div    v-if="willAlarm"
                    :class="alarmError ? 'text-red-500' : 'text-green-500'"
                    class="text-red-500 text-xs">
                <span>{{ willAlarm }}</span>
            </div>

        </div>
        <div class="border-t border-gray-200">
            <div class="-mt-px flex">
                <div class="w-0 flex-1 flex border-gray-200">
                    <div @click="$emit('save-alarm-profile', meter.id)" class="cursor-pointer relative w-0 flex-1 inline-flex items-center justify-center py-4 text-sm leading-5 text-gray-700 font-medium border border-transparent rounded-bl-lg hover:text-gray-500 focus:outline-none focus:ring-blue-200 focus:border-blue-300 focus:z-10">
                        <span class="lnr icon-check"></span>
                        <span class="ml-3">Save</span>
                    </div>
                </div>
            </div>
        </div>
    </li>

</template>

<script>
    import axios from 'axios';
    import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";

    export default {
        name: "InstallWizardAlarmActivationCard",
        mixins: [SonicuCoreMixin],
        props: {
            alarmProfiles: {
                type: Object,
                default: function() {
                    return {}
                },
            },
            meter: {
                type: Object,
                default: function() {
                    return {
                        name: 'Default Input',
                        type: 'Digital Glycol',
                        alarmProfile: null,
                    }
                }
            }
        },
        data() {
            return {
                alarmTextDefault: 'Checking If Point will Alarm',
                willAlarm: null,
                alarmError: false,
            }
        },
        created() {
            this.willAlarm = this.alarmTextDefault
        },
        mounted() {
            let component = this
            setTimeout(function() {
                component.checkAlarm()
            }, 200)

        },
        methods: {
            checkAlarm(event) {
                this.willAlarm = this.alarmTextDefault
                this.alarmError = false
                axios.get(this.company.buildCompanyApiInternalRoute('alarm-profile/check-alarm/' + this.meter.id + "?alarm_profile_id=" + this.meter.alarmProfile)).then(
                    response => {
                        let data = response['data']
                        this.willAlarm = data.message
                        this.alarmError = data.error
                    }
                )
            }
        }
    }
</script>

<style scoped>

</style>